import type { ActionParameterType } from './actionString.types';

export function param<TName extends string, TType extends ActionParameterType>(
  name: TName,
  type: TType,
) {
  return { name, type };
}

param.string = <TName extends string>(name: TName) => param(name, 'string');
param.number = <TName extends string>(name: TName) => param(name, 'number');
param.boolean = <TName extends string>(name: TName) => param(name, 'boolean');

param.optionalString = <TName extends string>(name: TName) => param(name, 'string?');
param.optionalNumber = <TName extends string>(name: TName) => param(name, 'number?');
param.optionalBoolean = <TName extends string>(name: TName) => param(name, 'boolean?');
